import { wrapper } from '../request';
export var searchUsers = wrapper('users')('search');